import React, { useContext } from "react";
import OrderStatesEnum from "../../../models/OrderStatesEnum";
import OwButton from "../../shared/OwButton/OwButton";
import IOrder from "../../../models/IOrder";
import SupplierContext from "../../../contexts/SupplierContext";
import OrderEntryViewStateOptionsEnum from "../../../models/OrderEntryViewStateOptionsEnum";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTextArea from "@components/shared/OwTextArea/OwTextArea";

type Props = {
    order?: IOrder;
    currentView: OrderEntryViewStateOptionsEnum;
    hasOneRmaRowChecked: () => boolean;
    createRma: (options: { notes?: string; tracking_number?: string }) => void;
    cancelRma: () => void;
    isCreatingRma: boolean;
};

export const OrderEntryRmaButtons = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const [state, setState] = React.useState({
        notes: "",
        tracking_number: "",
    });

    if (
        props.order?.order_state_id === OrderStatesEnum.PRELIMINARY ||
        !supplierModel.has_rma ||
        props.currentView !== OrderEntryViewStateOptionsEnum.RMA
    ) {
        return null;
    }

    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        setState({
            ...state,
            [name]: value,
        });
    };

    return (
        <div className={"ms-2"}>
            <div>
                <div>
                    <OwButton
                        title={"create_rma"}
                        fn={() => {
                            props.createRma(state);
                        }}
                        disabled={!props.hasOneRmaRowChecked() || props.isCreatingRma}
                        active={props.isCreatingRma}
                    />
                    <OwButton title={"cancel"} fn={props.cancelRma} className={"ms-2 btn-danger"} disabled={props.isCreatingRma} />
                </div>
                <div className={"mt-4"}>
                    <OwLabel title={"notes"} />
                    <OwTextArea name={"notes"} value={state.notes} fn={handleChange} placeholder={"notes"} />
                </div>
                <div className={"mt-2 mb-4"}>
                    <OwLabel title={"tracking"} />
                    <OwInputWrapper
                        name={"tracking_number"}
                        type={"text"}
                        value={state.tracking_number}
                        fn={handleChange}
                        placeholder={"tracking"}
                    />
                </div>
            </div>
        </div>
    );
};
